export const getRandomId = (): string => `id-${Math.random().toString(36).substr(2, 9)}`;
